export const SET_SELECTED_FOR_COMPOSITION_GROUP_IDS = 'SET_SELECTED_FOR_COMPOSITION_GROUP_IDS'
